import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './Icon';

// Provider bottom-tab navigation. Order matches the mobile app (task #660):
//   1. Buyurtmalar  2. Daromad  3. Bildirishnomalar  4. Profil
const TABS = [
  { label: 'Buyurtmalar', icon: 'package', path: '/provider/orders' },
  { label: 'Daromad', icon: 'wallet', path: '/provider/earnings' },
  { label: 'Bildirishnomalar', icon: 'bell', path: '/provider/notifications' },
  { label: 'Profil', icon: 'user', path: '/provider/profile' },
];

export default function ProviderLayout({ title, children }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div style={s.shell}>
      <header style={s.header}>
        <span style={s.headerTitle}>{title}</span>
      </header>

      <main style={s.main}>{children}</main>

      <nav style={s.tabBar} aria-label="Asosiy menyu">
        {TABS.map((tab) => {
          const active = location.pathname === tab.path;
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className="th-tab-btn"
              style={{ ...s.tab, ...(active ? s.tabActive : {}) }}
            >
              <span style={s.tabIcon}>
                <Icon name={tab.icon} size={22} color={active ? 'var(--color-text)' : 'var(--color-text-muted)'} />
              </span>
              <span style={{ ...s.tabLabel, color: active ? 'var(--color-text)' : 'var(--color-text-muted)' }}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}

const s = {
  shell: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: 'var(--color-bg)',
    fontFamily: 'var(--font-family)',
    maxWidth: '520px',
    margin: '0 auto',
  },
  header: {
    background: 'var(--color-dark)',
    padding: '16px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  headerTitle: { fontSize: '18px', fontWeight: '700', color: 'var(--color-on-dark)' },
  main: { flex: 1, padding: '16px', paddingBottom: '84px' },
  tabBar: {
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: 0,
    width: '100%',
    maxWidth: '520px',
    display: 'flex',
    background: 'var(--color-surface)',
    borderTop: '1px solid var(--color-border)',
    height: '64px',
    zIndex: 20,
  },
  tab: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3px',
    background: 'transparent',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    borderTop: '3px solid transparent',
    cursor: 'pointer',
    padding: '6px 2px',
  },
  tabActive: { borderTopColor: 'var(--color-primary)' },
  tabIcon: { display: 'inline-flex', lineHeight: 1 },
  tabLabel: { fontSize: '10px', fontWeight: '500' },
};
